module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8003.1acbad8c.png";